import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { UserContext } from '../../contexts/UserContext';
import { db } from '../../services/firebase';
import { doc, getDoc } from 'firebase/firestore';
import AffiliateTracker from './AffiliateTracker';
import './TrackingRedirect.css';

const TrackingRedirect = () => {
  const { trackingId } = useParams();
  const { user } = useContext(UserContext);
  const [error, setError] = useState(null);
  const [trackingData, setTrackingData] = useState(null);

  useEffect(() => {
    const handleRedirect = async () => {
      try {
        // Get tracking data from Firestore
        const trackingRef = doc(db, 'linkTracking', trackingId);
        const trackingDoc = await getDoc(trackingRef);

        if (!trackingDoc.exists()) {
          setError('Tracking link not found');
          return;
        }

        const data = trackingDoc.data();
        setTrackingData(data);

        // Track the click
        await AffiliateTracker.trackClick(
          trackingId, 
          user?.uid || null,
          {
            referrer: document.referrer,
            userAgent: navigator.userAgent,
            timestamp: new Date().toISOString()
          }
        );

        // Small delay to ensure tracking is recorded
        setTimeout(() => {
          // Redirect to the actual URL
          window.location.href = data.wrappedUrl || data.originalUrl;
        }, 500);

      } catch (err) {
        console.error('Error handling redirect:', err);
        setError('Error processing redirect');
      }
    };

    if (trackingId) {
      handleRedirect();
    } else {
      setError('No tracking ID provided');
    }
  }, [trackingId, user]);

  if (error) {
    return (
      <div className="tracking-redirect">
        <div className="redirect-container">
          <div className="error-state">
            <h2>Link Error</h2>
            <p>{error}</p>
            <p>
              <a href="/shop">← Return to Shop</a>
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="tracking-redirect">
      <div className="redirect-container">
        <div className="loading-state">
          <div className="spinner"></div>
          <h2>Redirecting...</h2>
          <p>Taking you to your destination</p>
          
          {trackingData && (
            <div className="redirect-info">
              <p>
                <strong>Product:</strong> {trackingData.productId}
              </p>
              <p>
                <strong>Source:</strong> {trackingData.source}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TrackingRedirect;